import styled from 'styled-components/macro';
import { GapProps } from '.';

export const GapComponent = styled.div<GapProps>`
  height: ${({ height }) => height}rem;
`;
